import { Entry } from './entry';
export class Settings {

    isSoundEnambled : boolean;
    notification : {};
    billingEmail: Array<Entry> = [];
    mobile : Array<Entry> = [];
    billingEmailIndex?: number;
    billingMobileIndex?: number;

    constructor(obj) {
        this.isSoundEnambled = obj.isSoundEnambled;
        this.notification = obj.notification;
        this.billingEmail = obj.billingEmail?obj.billingEmail: [];
        this.mobile = obj.mobile?obj.mobile: [];
        this.billingEmailIndex =obj.billingEmailIndex ;
        this.billingMobileIndex =obj.billingMobileIndex ;
    }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/settings.ts